



















import { Component, Prop, Vue } from 'vue-property-decorator';
import { Events, Items, Props } from './types';

const { CHANGE } = Events;

@Component
export default class AppTabMenu extends Vue implements Props {
  @Prop({ type: Array, default: () => [] })
  readonly items!: Items;

  @Prop({ type: Number, default: -1 })
  readonly current!: number;

  get list() {
    return this.items.map((item, index) => ({
      ...item,
      classes: { 'tabs-menu__link_current': this.isSelected(index) },
    }));
  }

  isSelected(index: number) {
    return index === this.current;
  }

  onClick(index: number) {
    this.$emit(CHANGE, index);
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/uikit/components/AppTabMenu/AppTabMenu.vue